import cx from 'classnames'
import { useEffect } from 'react'

import { UA } from '@js/common/UA'
import { isClientSide } from '@js/common/utils'

import { usePageHeader } from '../PageHeaderSSR'

interface PageHeaderWrapperProps {
  children: React.ReactNode
}

export const Wrapper = ({ children }: PageHeaderWrapperProps) => {
  const {
    appearance,
    is_full_width = false,
    sales_agent_app_page = false
  } = usePageHeader()

  const appearanceStyles = {
    logo_only: '[ f-wrap f-d-flr f-fl-jc-sb f-fl-al-ce ] PageHeader-bar',
    logo_social: '[ f-wrap f-d-flr f-fl-jc-sb f-fl-al-ce ] PageHeader-bar',
    logo_with_rating:
      '[ f-wrap f-d-flr f-fl-jc-sb f-fl-al-ce ] PageHeader-bar PageHeader-bar--with-rating',
    logo_with_rating_light:
      '[ f-wrap f-d-flr f-fl-jc-sb f-fl-al-ce ] PageHeader-bar PageHeader-bar--with-rating',
    standard: 'f-d-flr f-fl-jc-sb f-fl-al-ce PageHeader-bar'
  }

  useEffect(() => {
    if (
      isClientSide &&
      window.mountHeader &&
      /is-sticky/.test(window.mountHeader.className)
    ) {
      const pageHeaderWrapper = window.mountHeader

      const initScrollTrigger = async () => {
        const { gsap } = await import(
          /*
        webpackChunkName: "gsap",
        webpackMode: "lazy"
      */
          'gsap'
        )

        const { ScrollTrigger } = await import(
          /*
        webpackChunkName: "ScrollTrigger",
        webpackMode: "lazy"
      */
          'gsap/ScrollTrigger'
        )

        window.requestAnimationFrame = window.requestAnimationFrame.bind(window)
        gsap.registerPlugin(ScrollTrigger)

        ScrollTrigger.create({
          trigger: document.querySelector('body') as Element,
          start: 'top',
          end: 56,
          onLeave: () =>
            pageHeaderWrapper.classList.add(
              'is-scrolled',
              UA.isLoggedIn() ? 'is-logged-in' : 'is-not-logged-in'
            ),
          onEnterBack: () =>
            pageHeaderWrapper.classList.remove(
              'is-scrolled',
              'is-not-logged-in'
            )
        })
      }
      initScrollTrigger()
    }
  }, [])

  return (
    <div
      className={cx(
        appearanceStyles[appearance],
        is_full_width ? 'is-full-width f-p-h-020' : 'f-wrap',
        sales_agent_app_page && 'f-hidden'
      )}>
      {children}
    </div>
  )
}
